import { render } from "./ProfileNotifications.vue?vue&type=template&id=7ef1881c"
import script from "./ProfileNotifications.vue?vue&type=script&lang=js"
export * from "./ProfileNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__